import { render, staticRenderFns } from "./GrantCard.vue?vue&type=template&id=3c07c170&scoped=true&"
import script from "./GrantCard.vue?vue&type=script&lang=js&"
export * from "./GrantCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c07c170",
  null
  
)

export default component.exports